app.controller('studentExerciseEvalPerformCtrl', [
    '$scope', '$rootScope', '$http', '$mdDialog', 'gameService', '$state', '$stateParams', '$log', 'stopwatchService', 'analyticsService', function ($scope, $rootScope, $http, $mdDialog, gameService, $state, $stateParams, $log, stopwatchService, analyticsService) {
        var vm = this;

        vm.gameService = gameService;
        vm.gameState = gameService.getGameState();
        vm.exercise = gameService.exerciseWithIndex($stateParams.id);
        vm.question = gameService.lookupEvaluationQuestion(vm.exercise.index, $stateParams.question);

        stopwatchService.start("exercise_eval_question", vm.exercise.id, $stateParams.question);

        vm.progressIndex = 1 + vm.exercise.questions.length + 1 + $stateParams.question;
        vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length + 1;
	    vm.progressArray = new Array(vm.progressCount);

        // Create object for this exercise question.
        if (vm.gameState.evaluationAnswers == null) {
            vm.gameState.evaluationAnswers = {};
        }

        var evaluationQuestionAnswers = vm.gameState.evaluationAnswers[$stateParams.id];
        if (evaluationQuestionAnswers == null) {
            evaluationQuestionAnswers = {};
        }

        var evaluationQuestionAnswerArray = evaluationQuestionAnswers[$stateParams.question];
        if (evaluationQuestionAnswerArray == null) {
            evaluationQuestionAnswerArray = [];
        }

    	vm.points = 40;

    	vm.activeAnswers = [ true, true, true, true ];
        vm.done = false;

        var parent = angular.element("#eearrow")[0];
        vm.arrow = new TivoliArrow(parent);
        vm.arrow.start();

        $scope.$on('$destroy', function() {
            vm.arrow.stop();
            vm.arrow = null;
        });

        vm.popupShown = false;
        vm.answer = null;
        vm.answerIndex = 0;

        vm.performAnswer = function(idx) {
            var answerObj = vm.question.answers[idx];

            // Add to list of evaluation answers.
            evaluationQuestionAnswerArray.push(idx);

            // Don't do anything if the answer isn't active.
            if (!vm.activeAnswers[idx]) {
                return;
            }

            analyticsService.event("exercise_eval_question_answered", {
                "exercise_id": vm.exercise.id,
                "exercise_version": vm.exercise.version,
                "question_idx": $stateParams.question,
                "answer_idx": idx,
                "correct": vm.question.answers[idx].correct
            });

            if (vm.question.answers[idx].correct) {

                var numTries = vm.activeAnswers.reduce(function(acc, val) {
                    if (val == false) {
                        acc += 1;
                    }
                    return acc;
                }, 0);

                stopwatchService.stop("exercise_eval_question", vm.exercise.id, $stateParams.question);
                var stopwatch = stopwatchService.get("exercise_eval_question", vm.exercise.id, $stateParams.question);
                analyticsService.event("exercise_eval_question_completed", {
                    "exercise_id": vm.exercise.id,
                    "exercise_version": vm.exercise.version,
                    "question_idx": $stateParams.question,
                    "start_time": stopwatch.start,
                    "end_time": stopwatch.stop,
                    "elapsed_time": stopwatch.elapsed,
                    "num_tries": numTries
                });

                vm.activeAnswers = [ false, false, false, false ];
                vm.next();
                return;
            }

            vm.answerIndex = idx;
            vm.answer = answerObj;
            vm.popupShown = true;
        }

        vm.hidePopup = function() {
            var idx = vm.answerIndex;

            vm.activeAnswers[idx] = false;
            vm.points -= 10;
            vm.popupShown = false;
        }

        vm.next = function() {
            vm.gameState.score += vm.points;

            // Update evaluation status.
            evaluationQuestionAnswers[$stateParams.question] = evaluationQuestionAnswerArray;
            vm.gameState.evaluationAnswers[$stateParams.id] = evaluationQuestionAnswers;

            // Go next evaluation question?
            if ($stateParams.question < vm.exercise.evaluationQuestions.length - 1) {
                vm.gameState.evaluationQuestionIndex += 1;

                gameService.setGameState(vm.gameState).then(function() {
                    $state.go('student.exerciseevalperform', { id: $stateParams.id, question: vm.gameState.evaluationQuestionIndex });
                });
            // Go done?
            } else if ($stateParams.question === vm.exercise.evaluationQuestions.length - 1) {
                stopwatchService.stop("exercise", vm.exercise.id);
                var stopwatch = stopwatchService.get("exercise", vm.exercise.id);
                analyticsService.event("exercise_completed", {
                    "exercise_id": vm.exercise.id,
                    "exercise_version": vm.exercise.version,
                    "start_time": stopwatch.start,
                    "end_time": stopwatch.stop,
                    "elapsed_time": stopwatch.elapsed, 
                });

                // Last exercise? Go to trophy.
                if (vm.gameService.exercises.length - 1 === vm.gameState.exerciseIndex) {
                    vm.gameState.exerciseIndex += 1;
                    vm.gameState.questionIndex = 0;
                    vm.gameState.evaluationQuestionIndex = 0;
                    gameService.setGameState(vm.gameState).then(function() {
                        $state.go('student.trophy');
                    });
                // Else, do as normal.
                } else {
                    vm.gameState.exerciseIndex += 1;
                    vm.gameState.questionIndex = 0;
                    vm.gameState.evaluationQuestionIndex = 0;
                    
                    gameService.setGameState(vm.gameState).then(function() {
                        $state.go('student.exercisedone', { id: $stateParams.id });
                    });
                }
            }
        }
    }
]);